var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.64392L0 11.5533L12 18.4626L24 11.5533L12 4.64392ZM13.8033 9.02056C14.7796 8.45694 14.7796 7.54312 13.8033 6.9795C12.827 6.41587 11.2441 6.41587 10.2678 6.9795C9.29146 7.54312 9.29146 8.45694 10.2678 9.02056C11.2441 9.58419 12.827 9.58419 13.8033 9.02056Z",
    fill: "#39DAB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.8897 9.2832L0 15.5533L12 22.4626L24 15.5533L13.1341 9.29691C12.4271 9.49654 11.5908 9.49197 10.8897 9.2832Z",
    fill: "#39DAB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.00006L0 7.90939L12 14.8187L24 7.90939L12 1.00006ZM13.8033 9.0205C14.7796 8.45688 14.7796 7.54306 13.8033 6.97944C12.827 6.41581 11.2441 6.41581 10.2678 6.97944C9.29146 7.54306 9.29146 8.45688 10.2678 9.0205C11.2441 9.58412 12.827 9.58412 13.8033 9.0205Z",
    fill: "#39DAB1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureColor);
export default __webpack_public_path__ + "static/media/feature-color.2984fb2b8418a97bb339271760295e26.svg";
export { ForwardRef as ReactComponent };